import { useEffect, useState } from 'react';

interface UseFetchChartDataParams<T> {
  apiRequest: () => Promise<T>;
  onLoaded: () => void;
}

export const useFetchChartData = <T>({ apiRequest, onLoaded }: UseFetchChartDataParams<T>) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [chartData, setChartData] = useState<T>();

  useEffect(() => {
    if (!isLoading) {
      onLoaded();
    }
  }, [isLoading]);

  useEffect(() => {
    const fetchChartData = async () => {
      setIsLoading(true);
      try {
        const data = await apiRequest();
        setChartData(data);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchChartData();
  }, []);

  return { isLoading, chartData };
};
